import React from 'react';
import moment from 'moment';
import Interwave from 'interweave';
// import Avatar from '../../../../components/avatar';
import { TNewsDetail } from '../../../../types/news';
import { ArticleSC } from './article.styled';
import { getDateFormat } from '../../../../helpers/utils-helpers';

type TProps = {
  newsDetail: TNewsDetail;
};

const Article: React.FC<TProps> = ({ newsDetail }) => {
  return (
    <ArticleSC>
      {newsDetail.headingImageURL ? (
        <img
          className="article-main-img"
          src={newsDetail.headingImageURL}
          alt={newsDetail.imageDescription || ''}
        />
      ) : null}
      <div className="article-padding">
        <div className="article-meta">
          {/* <Avatar isDoctor size={22} />
          <span>Full Name</span>
          <span>|</span> */}
          <span>{moment(newsDetail.publishedAt).format(getDateFormat())}</span>
        </div>
        <h1>{newsDetail.title}</h1>
        <Interwave content={newsDetail.text} />
      </div>
    </ArticleSC>
  );
};

export default Article;
